module.exports = __webpack_public_path__ + "img/stop.4043a28d.png";